import { render } from "./ProfileSubscriptions.vue?vue&type=template&id=cfe863ec&scoped=true"
import script from "./ProfileSubscriptions.vue?vue&type=script&lang=js"
export * from "./ProfileSubscriptions.vue?vue&type=script&lang=js"

import "./ProfileSubscriptions.vue?vue&type=style&index=0&id=cfe863ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfe863ec"]])

export default __exports__